export type LinkedDocumentationItem = {
  name: string;
  description?: string;
  _id?: string;
  localId?: number;
  documentationId?: string;
  versionId?: string;
  imageRotation?: number;
  sourceDocumentId?: string;
  createdAt?: string;
  createdBy?: string;
  documentationName?: string;
  label?: string;
  deleted: boolean;
};

export type LinkedDocumentationOnView<TFile = unknown> = {
  id: string;
  title: string;
  file?: TFile;
};

export type LinkedDocPreview = {
  url: string;
  imageSignedRequest?: string;
  thumbnailSignedRequest?: string;
  mergedSignedRequest?: string;
  mergedThumbnailSignedRequest?: string;
  drawingSignedRequest?: string;
  imageRotation?: number;
  viaServiceWorker?: boolean;
};

export type RequestableLinkedDocumentationItem = LinkedDocumentationItem & {
  documentationId: string;
  versionId: string;
};

export enum ResourceLoadStatus {
  Idle = 'idle',
  Loading = 'loading',
  Ready = 'ready',
  Error = 'error',
}

export type LinkedDocumentationResourceMeta = {
  status: ResourceLoadStatus;
  requestedAt?: number;
  fetchedAt?: number;
  expiresAt?: number;
  nextRetryAt?: number;
  retryCount: number;
  lastError?: string;
};

export type MaybeNumber = number | null | undefined;

export type LinkedDescriptionMap = Record<string, string>;

export type CreateLinkedDocumentationItemParams = {
  documentationId: string;
  versionId: string;
  sourceDocumentId?: string;
  nameCandidates: Array<string | undefined | null>;
  descriptionCandidates?: Array<string | undefined | null>;
  imageRotationCandidates?: MaybeNumber[];
};

export type LinkedDocumentationReference = {
  linkedDocumentationId?: string;
  documentationId?: string;
  versionId?: string;
};
